import * as localStorage from './localStorage.js';
/**
 * Wrapper to read an item from local storage. It will ensure the data read
 * is decoded and converted into an object that can be used by an application.
 */
export function getItem(key) {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : {};
}
/**
 * Wrapper to write item to local storage
 */
export function setItem(key, data) {
    // Json stringify first
    const item = JSON.stringify(data);
    // encode the value to be written and save off to local storage
    localStorage.setItem(key, item);
}
//# sourceMappingURL=jsonStorage.js.map